import React, { FC } from 'react';

import { useItineraryDetailsSearchFilter } from 'components/Pages/Admin/shared/SearchFilterForDetailsTab/function';
import { IItinerarySearchFilterButtonProps } from 'components/Pages/Admin/shared/SearchFilterForDetailsTab/types';
import BaseSearchFilterButton from 'components/shared/BaseSearchFilter/BaseSearchFilterButton';
import BaseSearchFilterForm from 'components/shared/BaseSearchFilter/BaseSearchFilterForm';
import Tooltip, { TooltipText, VARIANTS } from 'components/shared/Tooltip';

import s from './index.module.css';

export const ItineraryDetailsSearchFilterButton: FC<IItinerarySearchFilterButtonProps> = ({
  filter,
  filterName,
  filterKeyName,
  className,
  isRoundButton = false,
  isMobile = false,
  numberOfFilters,
}) => {
  const { defaultFilter, loading, showRadioButtons, handleSave, title, restoredFilter, handleDelete } =
    useItineraryDetailsSearchFilter({
      filter,
      filterName,
      filterKeyName,
    });

  return (
    <>
      <BaseSearchFilterButton
        isActive={!!filter}
        onDelete={handleDelete}
        className={className}
        isRoundButton={isRoundButton}
        isMobile={isMobile}
        numberOfFilters={numberOfFilters}
        renderFilterForm={({ onClose }) => (
          <BaseSearchFilterForm
            onDelete={handleDelete}
            defaultFilter={defaultFilter}
            filter={restoredFilter}
            loading={loading}
            onClose={onClose}
            showRadioButtons={showRadioButtons}
            onSave={handleSave}
            title={title}
          />
        )}
      />
      <Tooltip variant={VARIANTS.DARK} className={s.tooltip} place="top" id="filter">
        <TooltipText className={s.tooltipText}>Filter Content Pages</TooltipText>
      </Tooltip>
    </>
  );
};
